import { ROW_HEIGHT } from "@/constants/appointments/appointments-constants";
import {
  Popover,
  PopoverContent,
  PopoverAnchor,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface CreateAppointmentPopoverProps {
  rowIndex: number;
  timeString: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onNewAppointmentClick: () => void;
}

export function CreateAppointmentPopover({
  rowIndex,
  timeString,
  open,
  onOpenChange,
  onNewAppointmentClick,
}: CreateAppointmentPopoverProps) {
  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverAnchor
        className="absolute left-0 right-0 pointer-events-none"
        style={{
          top: `${rowIndex * ROW_HEIGHT}px`,
          height: `${ROW_HEIGHT}px`,
        }}
      />
      <PopoverContent className="w-auto p-3" align="center">
        <div className="flex flex-col gap-2">
          <p className="text-sm font-medium text-center">{timeString}</p>
          <Button size="sm" onClick={onNewAppointmentClick} className="w-full">
            <Plus className="h-4 w-4 mr-1" />
            New Appointment
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
